export default {
	showuser(state){
		return state.username
		
	}
}